import styled from 'styled-components';

export const BoxEmailInput = styled.div`
  margin-bottom: 13rem;
  button {
    display: inherit;
    margin: 0 auto;
  }
`;
